export const gamesWeOfferTextContent = {
  headingText: "Explore the Games We Offer",
  btnText: "View All Games",
  gamesWeOfferContent: [
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_01.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_02.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_03.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_04.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_05.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_06.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_07.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_08.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_09.webp",
      gameNameText: "",
    },
    {
      gameImageSrc: "/assets/stock-img/casino_game_img_10.webp",
      gameNameText: "",
    },
  ],
};
